<!-- src/js/widgets/manager-residency-requests/components/RequestDetail.vue -->
<template>
  <div class="manager-residency-requests__detail">
    <!-- НЕСКРОЛЯЩИЙСЯ ХЭДЕР -->
    <div class="manager-residency-requests__detail-header">
      <div class="manager-residency-requests__detail-header-section">
        <button class="manager-residency-requests__detail-back" @click="$emit('back')">
          <img :src="`${ICONS_BASE}/arrow-back-icon.svg`" alt="" class="manager-residency-requests__detail-back-icon" />
        </button>
        <h2>Заявка {{ request?.id }}</h2>
      </div>
      <div class="manager-residency-requests__detail-header-section">
        <ADropdown>
          <div class="manager-residency-requests__detail-status-select">
            <span :class="getStatusClass(
              selectedStatus.id,
              'manager-residency-requests__detail-status-select-dot',
            )
              " />
            <span class="manager-residency-requests__detail-status-select-label">
              {{ selectedStatus.name }}
            </span>
            <ArrowDownIcon class="manager-residency-requests__detail-status-select-icon" />
          </div>

          <template #overlay>
            <AMenu @click="changeStatus">
              <AMenuItem v-for="item in statusOptions" :key="item?.value as string" :class="{
                'selected':
                  item.value === selectedStatus.id,
              }">
                <div class="manager-residency-requests__detail-status-select-option" :class="{
                  'manager-residency-requests__detail-status-select-option--selected':
                    item.value === selectedStatus.id,
                }">
                  <span :class="getStatusClass(
                    item.value,
                    'manager-residency-requests__detail-status-select-dot',
                  )
                    " />
                  <span>{{ item.label }}</span>
                </div>
              </AMenuItem>
            </AMenu>
          </template>
        </ADropdown>
        <span v-if="activeTab !== 'history'" class="manager-residency-requests__detail-header-section-divider" />
        <button v-if="activeTab !== 'history'" type="button" class="btn btn-secondary btn-medium manager-residency-requests__detail-reply-button" @click="replyOpen = true" :disabled="loading" label="Ответ заявителю"><img :src="`${ICONS_BASE}/reply-icon.svg`" alt="" class="manager-residency-requests__detail-reply-button-icon" /><span>Ответ заявителю</span></button>
      </div>
    </div>

    <!-- КОНТЕЙНЕР ТАБОВ С ФИКСИРОВАННОЙ ВЫСОТОЙ -->
    <div class="manager-residency-requests__detail-tabs-container">
      <!-- Правильная структура Tabs -->
      <Tabs v-model:value="activeTab">
        <TabList>
          <Tab value="info">Основная информация</Tab>
          <Tab value="history">История изменений</Tab>
        </TabList>

        <TabPanels>
          <TabPanel value="info">
            <div class="general-information">
              <!-- Общее -->
              <div class="general-information__section">
                <h3 class="general-information__section-title">Общее</h3>

                <ul class="general-information__fields">
                  <li class="general-information__field">
                    <p class="general-information__field-label">Название компании</p>
                    <p class="general-information__field-value">
                      {{ request.companyName || '—' }}
                    </p>
                  </li>

                 <li v-if="Object.prototype.hasOwnProperty.call(request, 'shortNameCompany')" class="general-information__field">
                    <p class="general-information__field-label">Сокращенное название юр. лица или ИП</p>
                    <p class="general-information__field-value">
                      {{ request.shortNameCompany || '—' }}
                    </p>
                  </li>

                 <li v-if="Object.prototype.hasOwnProperty.call(request, 'legalForm')" class="general-information__field">
                    <p class="general-information__field-label">Организационно-правовая форма</p>
                    <p class="general-information__field-value">
                      {{ request.legalForm || '—' }}
                    </p>
                  </li>

                 <li v-if="Object.prototype.hasOwnProperty.call(request, 'ogrn')" class="general-information__field">
                    <p class="general-information__field-label">ОГРН/ОГРНИП</p>
                    <p class="general-information__field-value">
                      {{ request.ogrn || '—' }}
                    </p>
                  </li>

                 <li v-if="Object.prototype.hasOwnProperty.call(request, 'address')" class="general-information__field">
                    <p class="general-information__field-label">Адрес местонахождения</p>
                    <p class="general-information__field-value">
                      {{ request.address || '—' }}
                    </p>
                  </li>

                 <li v-if="Object.prototype.hasOwnProperty.call(request, 'registrationAuthority')" class="general-information__field">
                    <p class="general-information__field-label">Наименование органа осуществляющего государственную регистрацию</p>
                    <p class="general-information__field-value">
                      {{ request.registrationAuthority || '—' }}
                    </p>
                  </li>

                 <li v-if="Object.prototype.hasOwnProperty.call(request, 'registrationDate')" class="general-information__field">
                    <p class="general-information__field-label">Дата регистрации</p>
                    <p class="general-information__field-value">
                      {{ request.registrationDate || '—' }}
                    </p>
                  </li>

                 <li v-if="Object.prototype.hasOwnProperty.call(request, 'businessArea')" class="general-information__field">
                    <p class="general-information__field-label">Сфера деятельности</p>
                    <p class="general-information__field-value">
                      {{ request.businessArea || '—' }}
                    </p>
                  </li>

                 <li v-if="Object.prototype.hasOwnProperty.call(request, 'areaActivity')" class="general-information__field">
                    <p class="general-information__field-label">Сфера деятельности</p>
                    <p class="general-information__field-value">
                      {{ request.areaActivity || '—' }}
                    </p>
                  </li>

                  <li v-if="Object.prototype.hasOwnProperty.call(request, 'cluster')" class="general-information__field">
                    <p class="general-information__field-label">Кластер</p>
                    <p class="general-information__field-value">
                      {{ request.cluster || '—' }}
                    </p>
                  </li>

                 <li v-if="Object.prototype.hasOwnProperty.call(request, 'educationType')" class="general-information__field">
                    <p class="general-information__field-label">Виды, уровни образования, планируемые к осуществлению на территории ИНТЦ</p>
                    <p v-if="request.educationType?.length === 0" class="general-information__field-value">
                      —
                    </p>
                    <ul v-else class="general-information__field-list">
                      <li v-for="item in request.educationType" :key="item as string" class="general-information__field-list-item">
                        <p class="general-information__field-value">
                          {{ '- ' + item }}
                        </p>
                      </li>
                    </ul>
                  </li>

                 <li v-if="Object.prototype.hasOwnProperty.call(request, 'implementationForm')" class="general-information__field">
                    <p class="general-information__field-label">Формы реализации образовательной деятельности на территории ИНТЦ</p>
                    <p v-if="request.implementationForm?.length === 0" class="general-information__field-value">
                      —
                    </p>
                    <ul v-else class="general-information__field-list">
                      <li v-for="item in request.implementationForm" :key="item as string" class="general-information__field-list-item">
                        <p class="general-information__field-value">
                          {{ '- ' + item }}
                        </p>
                      </li>
                    </ul>
                  </li>

                 <li v-if="Object.prototype.hasOwnProperty.call(request, 'projectDescription')" class="general-information__field">
                    <p class="general-information__field-label">Описание проекта</p>
                    <p class="general-information__field-value">
                      {{ request.projectDescription || '—' }}
                    </p>
                  </li>

                 <li v-if="Object.prototype.hasOwnProperty.call(request, 'programDescription')" class="general-information__field">
                    <p class="general-information__field-label">Описание проекта</p>
                    <p class="general-information__field-value">
                      {{ request.programDescription || '—' }}
                    </p>
                  </li>

                 <li v-if="Object.prototype.hasOwnProperty.call(request, 'premises')" class="general-information__field">
                    <p class="general-information__field-label">Помещение</p>
                    <p class="general-information__field-value">
                      {{ request.premises || '—' }}
                    </p>
                  </li>
                 <li v-if="Object.prototype.hasOwnProperty.call(request, 'dateEvent')" class="general-information__field">
                    <p class="general-information__field-label">Дата мероприятия</p>
                    <p class="general-information__field-value">
                      {{ request.dateEvent || '—' }}
                    </p>
                  </li>
                 <li v-if="Object.prototype.hasOwnProperty.call(request, 'timeEvent')" class="general-information__field">
                    <p class="general-information__field-label">Время начала</p>
                    <p class="general-information__field-value">
                      {{ request.timeEvent || '—' }}
                    </p>
                  </li>
                 <li v-if="Object.prototype.hasOwnProperty.call(request, 'durationEvent')" class="general-information__field">
                    <p class="general-information__field-label">Продолжительность</p>
                    <p class="general-information__field-value">
                      {{ request.durationEvent || '—' }}
                    </p>
                  </li>
                 <li v-if="Object.prototype.hasOwnProperty.call(request, 'format')" class="general-information__field">
                    <p class="general-information__field-label">Формат мероприятия</p>
                    <p class="general-information__field-value">
                      {{ request.format || '—' }}
                    </p>
                  </li>
                 <li v-if="Object.prototype.hasOwnProperty.call(request, 'countParticipants')" class="general-information__field">
                    <p class="general-information__field-label">Количество участников</p>
                    <p class="general-information__field-value">
                      {{ request.countParticipants || '—' }}
                    </p>
                  </li>
                 <li v-if="Object.prototype.hasOwnProperty.call(request, 'additionalServices')" class="general-information__field">
                    <p class="general-information__field-label">Доп. услуги и оборудование</p>
                    <p v-if="request.additionalServices?.length === 0" class="general-information__field-value">
                      —
                    </p>
                    <ul v-else class="general-information__field-list">
                      <li v-for="item in request.additionalServices" :key="item as string" class="general-information__field-list-item">
                        <p class="general-information__field-value">
                          {{ '- ' + item }}
                        </p>
                      </li>
                    </ul>
                  </li>
                 <li v-if="Object.prototype.hasOwnProperty.call(request, 'wishes')" class="general-information__field">
                    <p class="general-information__field-label">Пожелания</p>
                    <p class="general-information__field-value">
                      {{ request.wishes || '—' }}
                    </p>
                  </li>
                </ul>
              </div>

              <!-- Контактное лицо -->
              <div class="general-information__section">
                <h3 class="general-information__section-title">Контактное лицо</h3>

                <ul class="general-information__fields">
                  <li class="general-information__field">
                    <p class="general-information__field-label">ФИО</p>
                    <p class="general-information__field-value">
                      {{ request.fio || '—' }}
                    </p>
                  </li>

                 <li v-if="Object.prototype.hasOwnProperty.call(request, 'workPosition')" class="general-information__field">
                    <p class="general-information__field-label">Должность</p>
                    <p class="general-information__field-value">
                      {{ request.workPosition || '—' }}
                    </p>
                  </li>

                  <li class="general-information__field">
                    <p class="general-information__field-label">Телефон</p>
                    <p class="general-information__field-value">
                      {{ request.phone || '—' }}
                    </p>
                  </li>

                  <li class="general-information__field">
                    <p class="general-information__field-label">Email</p>
                    <p class="general-information__field-value">
                      {{ request.email || '—' }}
                    </p>
                  </li>
                </ul>
              </div>

              <!-- Документы -->
              <div v-if="request?.files" class="general-information__section">
                <h3 class="general-information__section-title">Документы</h3>

                <ul class="general-information__fields">
                  <li class="general-information__field" v-for="file in request.files" :key="file.url">
                    <a :href="file.url" target="_blank" rel="noopener noreferrer" class="manager-residency-requests__detail-doc-row">
                      <span class="manager-residency-requests__detail-doc-icon-wrap">
                        <img class="manager-residency-requests__detail-doc-icon" :src="getFileIcon(file)" :alt="getFileExtension(file).toUpperCase()" />
                      </span>

                      <span class="manager-residency-requests__detail-doc-body">
                        <span class="manager-residency-requests__detail-doc-name">
                          {{ file.name }}
                        </span>

                        <span class="manager-residency-requests__detail-doc-meta">
                          <span class="manager-residency-requests__detail-doc-meta-format">
                            {{ getFileExtension(file).toUpperCase() }}
                          </span>

                          <span class="manager-residency-requests__detail-doc-meta-sep" aria-hidden="true">
                            /
                          </span>

                          <span class="manager-residency-requests__detail-doc-meta-size">
                            {{ file.size }}
                          </span>
                        </span>
                      </span>

                      <span class="manager-residency-requests__detail-doc-dl" aria-hidden="true">
                        <img :src="`${ICONS_BASE}/download-icon.svg`" alt="" width="24" height="24" />
                      </span>
                    </a>
                  </li>

                  <li v-if="!request.files?.length" class="general-information__field">
                    <p class="general-information__field-value">Документы отсутствуют</p>
                  </li>
                </ul>
              </div>

              <!-- Прочее -->
              <div class="general-information__section">
                <h3 class="general-information__section-title">Прочее</h3>

                <div>
                  <p class="general-information__field-label">Комментарий*</p>
                  <AFormItem class="stc-ant-field-skin general-information__message-field">
                    <ATextarea v-model:value="noteText" class="general-information__textarea" :rows="8" :maxlength="COMMENT_MAX_LENGTH" placeholder="Введите комментарий" />
                  </AFormItem>
                  <div class="general-information__textarea-counter-wrapper">
                    <p class="general-information__field-label">*не обязателен</p>
                    <div class="general-information__textarea-counter">
                      {{ noteText.length }} / {{ COMMENT_MAX_LENGTH }}
                    </div>
                  </div>

                  <div class="manager-residency-requests__detail-update-buttons">
                    <button v-if="hasStatusChanged" @click="resetStatus" :disabled="loading" class="btn btn-secondary btn-medium">Отмена</button>
                    <button v-if="hasStatusChanged" @click="saveStatus" class="btn btn-primary btn-medium manager-residency-requests__detail-save-btn" :disabled="loading">Сохранить</button>
                  </div>
                </div>
              </div>
            </div>
          </TabPanel>

          <!-- История статусов -->
          <TabPanel value="history">
            <template v-if="request.historyUpdate?.length">
              <div class="manager-residency-requests__table-wrapper personal-area-table-wrapper">
                <DataTable :value="paginatedHistory" scrollable>
                  <Column header="Дата / время">
                    <template #body="{ data }">
                      <span class="manager-residency-requests__detail-history-date">
                        {{ dayjs(data.date).format('DD.MM.YYYY / HH:mm') }}
                      </span>
                    </template>
                  </Column>

                  <Column header="Изменение статуса">
                    <template #body="{ data }">
                      <p class="personal-area-table__detail-history-status">
                        <span :class="getStatusClass(data?.oldStatus?.id ?? null)">{{
                          data.oldStatus.name
                          }}</span>
                        <img :src="`${ICONS_BASE}/arrow-right-transform.svg`" alt="" class="personal-area-table__transform-arrow-icon" />
                        <span :class="getStatusClass(data?.newStatus?.id ?? null)">{{
                          data.newStatus.name
                          }}</span>
                      </p>
                    </template>
                  </Column>

                  <Column header="Автор">
                    <template #body="{ data }">
                      {{ data.userChange || '' }}
                    </template>
                  </Column>
                </DataTable>
              </div>

              <Pagination v-model="historyPage" :total-count="historyTotalCount" :page-size="HISTORY_PAGE_SIZE" @change="handleHistoryPageChange" />
            </template>

            <div v-else class="manager-requests__detail-no-history">
              История статусов отсутствует
            </div>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </div>
  </div>

  <ADrawer :width="800" :open="replyOpen" class="reply-drawer" :body-style="{ paddingBottom: '24px' }" :footer-style="{ textAlign: 'left' }" @close="onCloseReply">
    <template #title>
      <div class="reply-drawer__header-shell">
        <div class="reply-drawer__header-overline">Ответ заявителю</div>
      </div>
    </template>

    <template #closeIcon>
      <span class="reply-drawer__close-trigger">
        <CloseOutlined />
      </span>
    </template>

    <AForm ref="formRef" :model="form" :rules="rules" layout="vertical">
      <p class="reply-drawer__field-label">Комментарий*</p>
      <AFormItem class="stc-ant-field-skin reply-drawer__message-field" name="comment">
        <ATextarea v-model:value="form.comment" class="reply-drawer__textarea" :rows="8" :maxlength="COMMENT_MAX_LENGTH" placeholder="Введите комментарий" />
        <div class="reply-drawer__textarea-counter-wrapper">
          <p class="reply-drawer__field-label">*не обязателен</p>
          <div class="reply-drawer__textarea-counter">
            {{ commentLength }} / {{ COMMENT_MAX_LENGTH }}
          </div>
        </div>
      </AFormItem>

      <hr class="reply-drawer__divider" />

      <FormFileUpload ref="documentsUploadRef" v-model="documentItems" />
    </AForm>

    <template #footer>
      <ARow align="middle" justify="space-between" class="reply-drawer__toolbar">
        <ACol :span="24" class="reply-drawer__toolbar-submit">
          <ASpace>
            <button type="button" class="btn btn-outline" @click="onCloseReply">Отмена</button>
            <button type="button" class="btn btn-primary" @click="onSubmit" :disabled="isSubmitDisabled">
              {{ isSubmitting ? 'Отправка…' : 'Отправить' }}
            </button>
          </ASpace>
        </ACol>
      </ARow>
    </template>
  </ADrawer>
</template>

<script setup lang="ts">
import { reactive, ref, watch, computed, nextTick } from 'vue';
import Pagination from '../../Pagination.vue';
import dayjs from 'dayjs';
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import type {
  Request,
  PermissionFormData,
  ApiStatusResponse,
  ApiStatus,
} from '../types';
import { CloseOutlined } from '@ant-design/icons-vue';
import type { FormInstance, Rule } from 'ant-design-vue/es/form';
import FormFileUpload from '@/js/components/form/form-file-upload.vue';
import ArrowDownIcon from '@/js/components/icons/ArrowDownIcon.vue';
import {
  Drawer as ADrawer,
  Form as AForm,
  FormItem as AFormItem,
  Row as ARow,
  Col as ACol,
  Space as ASpace,
  Textarea as ATextarea,
  Dropdown as ADropdown,
  Menu as AMenu,
  MenuItem as AMenuItem,
} from 'ant-design-vue';

const props = defineProps<{
  request: Request;
  loading: boolean;
}>();

const emit = defineEmits<{
  (e: 'close'): void;
  (e: 'status-updated', payload: { status?: ApiStatusResponse; text?: string }): void;
  (e: 'reply', payload: PermissionFormData): void;
  (e: 'back'): void;
}>();

const COMMENT_MAX_LENGTH = 512;
const HISTORY_PAGE_SIZE = 10;
const ICONS_BASE =
  process.env.NODE_ENV === 'development'
    ? '/assets/images/icons'
    : '/local/templates/dist/assets/images/icons';

const activeTab = ref('info');
const historyPage = ref(1);
const selectedStatus = ref<ApiStatusResponse>(props.request.status);
const noteText = ref(props.request.adminMessage || '');
const replyOpen = ref(false);

const formRef = ref<FormInstance>();
const documentsUploadRef = ref<InstanceType<typeof FormFileUpload> | null>(null);
const documentItems = ref([]);
const isSubmitting = ref(false);

const initialFormState = () => ({
  comment: '',
});

const form = reactive(initialFormState());

const commentLength = computed(() => form.comment.length);

const rules: Record<string, Rule[]> = {
  comment: [
    {
      required: false,
      whitespace: true,
      message: 'Введите комментарий',
    },
  ],
};

const isRequiredFieldsFilled = computed(
  () => form.comment.trim().length > 0 || documentItems.value.length > 0,
);

const isSubmitDisabled = computed(() => isSubmitting.value || !isRequiredFieldsFilled.value);

const historyTotalCount = computed(() => props.request.historyUpdate?.length ?? 0);

const paginatedHistory = computed(() => {
  if (!props.request.historyUpdate?.length) {
    return [];
  }

  const start = (historyPage.value - 1) * HISTORY_PAGE_SIZE;
  const end = start + HISTORY_PAGE_SIZE;

  return props.request.historyUpdate.slice(start, end);
});

const statusOptions = computed(() => {
  if (!props.request?.statuses || props.request?.statuses.length < 1) return [];
  return props.request.statuses.map((item) => ({
    value: item.id,
    label: item.name,
  }));
});

const hasStatusChanged = computed(() => {
  return (
    selectedStatus.value !== props.request.status ||
    noteText.value !== (props.request.adminMessage || '')
  );
});

watch(
  () => props.request.status,
  (newStatus) => {
    selectedStatus.value = newStatus;
  },
);
watch(
  () => props.request.adminMessage,
  (newText) => {
    noteText.value = newText || '';
  },
);

const getFileExtension = (file: { name: string; url: string }) => {
  const source = file.name || file.url;

  return source.split('.').pop()?.split('?')[0].toLowerCase() || 'file';
};

const getFileIcon = (file: { name: string; url: string }) => {
  const ext = getFileExtension(file);

  const availableIcons = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'zip', 'rar'];

  return availableIcons.includes(ext)
    ? `${ICONS_BASE}/doc/doc_${ext}.svg`
    : '${ICONS_BASE}/doc/doc_txt.svg';
};

function getStatusClass(stat?: ApiStatus | null, cl?: string): string {
  const baseClass = cl ?? 'personal-area-table__status';

  if (!stat) return baseClass;

  const extStatusClass = ` ${baseClass}--${stat.toString().toLowerCase().replace(/\s+/g, '-')}`;
  return baseClass + extStatusClass;
}

function handleHistoryPageChange(page: number) {
  historyPage.value = page;
}

function changeStatus({ key }: { key: string | number }) {
  const currentStatus = props.request.statuses?.find((item) => item.id === key);
  if (currentStatus) selectedStatus.value = currentStatus;
}

function saveStatus() {
  if (hasStatusChanged.value) {
    emit('status-updated', {
      status:
        selectedStatus.value.id !== props.request.status.id ? selectedStatus.value : undefined,
      text: noteText.value !== props.request.adminMessage ? noteText.value : undefined,
    });
  }
}

function resetStatus() {
  selectedStatus.value = props.request.status;
  noteText.value = props.request.adminMessage || '';
}

const resetFormState = () => {
  Object.assign(form, initialFormState());
  documentItems.value = [];
  documentsUploadRef.value?.reset();
  nextTick(() => {
    formRef.value?.clearValidate();
  });
};

const onCloseReply = () => {
  resetFormState();
  replyOpen.value = false;
};

const onSubmit = async () => {
  if (!formRef.value) {
    return;
  }

  try {
    await formRef.value.validate();
  } catch {
    return;
  }

  isSubmitting.value = true;
  documentsUploadRef.value?.setSubmittingState(true);

  try {
    const readyFiles = documentsUploadRef.value?.getReadyFiles() ?? [];

    emit('reply', {
      comment: form.comment,
      files: readyFiles,
    });
    isSubmitting.value = false;
    onCloseReply();
  } catch (err) {
    console.error('Ошибка отправки ответа:', err);
  }
};
</script>

<style>
.reply-drawer .ant-drawer-body {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.reply-drawer .reply-drawer__close-trigger {
  display: flex;
  justify-content: flex-end;
}

.reply-drawer .ant-form {
  width: 100%;
}

.reply-drawer .ant-drawer-header-title {
  flex-direction: row-reverse;
}

.reply-drawer__header-shell {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.reply-drawer__header-overline {
  font-size: 24px;
  font-family: var(--stc-font-semibold), sans-serif;
  color: var(--stc-black);
}

.reply-drawer .reply-drawer__message-field {
  margin-top: 10px;
}

.reply-drawer .reply-drawer__textarea {
  :deep(.ant-input) {
    resize: vertical;
  }
}

.reply-drawer .reply-drawer__textarea-counter-wrapper {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  font-family: var(--stc-font-regular), sans-serif;
  font-size: 12px;
  line-height: 153%;
  color: var(--stc-gray-400);
}

.reply-drawer .reply-drawer__field-label {
  font-family: var(--stc-font-regular), sans-serif;
  font-size: 12px;
  line-height: 153%;
  margin: 0;
  color: var(--stc-gray-400);
}

.reply-drawer .reply-drawer__divider {
  margin: 40px 0;
  opacity: 1;
  color: var(--stc-gray-100)
}

.reply-drawer .form-file-upload__dropzone {
  height: 256px;
}

.reply-drawer .ant-drawer-footer {
  padding: 30px 20px;
  display: flex;
  justify-content: flex-end;
}
</style>
